import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from 'src/app/services/http-client.service';

@Injectable()
export class AdminService {
    constructor(private _httpService: HttpClientService) { }

    getAllCourses(): Observable<any> {
        return this._httpService.get<any>(
            '/admin/courses'
        );
    }

    getAllEvents(): Observable<any> {
        return this._httpService.get<any>(
            '/admin/events'
        );
    }

    getAllBlogs(): Observable<any> {
        return this._httpService.get<any>(
            '/admin/blogs'
        );
    }

    postBlog(blogModel: any): Observable<any> {
        return this._httpService.post<any, any>(
            '/blog', blogModel
        );
    }

    postEvent(eventModel: any): Observable<any> {
        return this._httpService.post<any, any>(
            '/event', eventModel
        );
    }

    postCourse(courseModel: any): Observable<any> {
        return this._httpService.post<any, any>(
            '/course', courseModel
        );
    }

    putBlog(blogID: any, blogModel: any): Observable<any> {
        return this._httpService.put<any, any>(
            '/blog/' + blogID, blogModel
        );
    }

    putEvent(eventID: any, eventModel: any): Observable<any> {
        return this._httpService.put<any, any>(
            '/event/' + eventID, eventModel
        );
    }

    putCourse(courseID: any, courseModel: any): Observable<any> {
        return this._httpService.put<any, any>(
            '/course/' + courseID, courseModel
        );
    }

    deleteBlog(blogID: any): Observable<any> {
        return this._httpService.delete<any>(
            '/blog/' + blogID
        );
    }

    deleteEvent(eventID: any): Observable<any> {
        return this._httpService.delete<any>(
            '/event/' + eventID
        );
    }

    deleteCourse(courseID: any): Observable<any> {
        return this._httpService.delete<any>(
            '/course/' + courseID
        );
    }

    getBlogById(blogID: any): Observable<any> {
        return this._httpService.get<any>(
            '/blog/' + blogID
        );
    }

    getEventById(eventID: any): Observable<any> {
        return this._httpService.get<any>(
            '/event/' + eventID
        );
    }

    getCourseById(courseID: any): Observable<any> {
        return this._httpService.get<any>(
            '/course/' + courseID
        );
    }
}
